import React from 'react'
import { useTranslation } from 'react-i18next'
import {
    ContactUsModal,
    CookieConsentModal,
    OthersModal,
    SportsModal,
    SportEventModal,
    TryItOutModal,
    JoinCommunityModal,
} from './'
import { getFootballDetails, getVolleyballDetails } from './sportDetails'
import { useModalStore } from '../../store/ModalStore'
import { useModalDataStore } from '../../store/ModalDataStore'
import { MODAL_STATE } from '../../types/modals'

export const ModalsAggregator: React.FC = () => {
    const { t } = useTranslation()
    const { isModalOpen, closeModal } = useModalStore()
    const { clearData } = useModalDataStore()

    const handleCloseModal = () => {
        clearData()
        closeModal()
    }

    return (
        <>
            {/* Try it out Modal */}
            <TryItOutModal
                isOpen={isModalOpen(MODAL_STATE.TRY_IT)}
                onClose={handleCloseModal}
            />

            {/* Sports - Football Modal */}
            <SportsModal
                isOpen={isModalOpen(MODAL_STATE.FOOTBALL)}
                onClose={handleCloseModal}
                sportDetails={getFootballDetails(t)}
            />

            {/* Sports - Volleyball Modal */}
            <SportsModal
                isOpen={isModalOpen(MODAL_STATE.VOLLEYBALL)}
                onClose={handleCloseModal}
                sportDetails={getVolleyballDetails(t)}
            />

            {/* Others Modal */}
            <OthersModal
                isOpen={isModalOpen(MODAL_STATE.OTHERS)}
                onClose={handleCloseModal}
            />

            {/* Sport Event Modal */}
            <SportEventModal
                isOpen={isModalOpen(MODAL_STATE.SPORT_EVENT)}
                onClose={handleCloseModal}
            />

            {/* Contact Us Modal */}
            <ContactUsModal
                isOpen={isModalOpen(MODAL_STATE.CONTACT_US)}
                onClose={handleCloseModal}
            />

            {/* Cookie Consent Modal */}
            <CookieConsentModal
                isOpen={isModalOpen(MODAL_STATE.COOKIE_CONSENT)}
                onClose={handleCloseModal}
            />

            {/* Join Community Modal */}
            <JoinCommunityModal
                isOpen={isModalOpen(MODAL_STATE.JOIN_COMMUNITY)}
                onClose={handleCloseModal}
            />
        </>
    )
}
